import { render } from "./DynamicHtmlBr.vue?vue&type=template&id=03a2e2d2&ts=true"
import script from "./DynamicHtmlBr.vue?vue&type=script&lang=ts"
export * from "./DynamicHtmlBr.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicHtmlBr.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03a2e2d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03a2e2d2', __exports__)) {
    api.reload('03a2e2d2', __exports__)
  }
  
  module.hot.accept("./DynamicHtmlBr.vue?vue&type=template&id=03a2e2d2&ts=true", () => {
    api.rerender('03a2e2d2', render)
  })

}


export default __exports__